import { sortBySortOrder } from '@ml/common';
import { ActionSet } from './action-set';
import { OptionMenuGroup } from './floorplan-vm';
import { OptionVM } from './option-vm';

export class OptionMenuGroupVM {
  OptionMenuGroupId: number;
  FloorPlanId: number;
  Name: string;
  Options: OptionVM[] = [];

  constructor(optMenuGroup: OptionMenuGroup, allAsets: ActionSet[]) {
    if (optMenuGroup && optMenuGroup.OptionMenuGroupToActionSet?.length) {
      this.OptionMenuGroupId = optMenuGroup.OptionMenuGroupId;
      this.FloorPlanId = optMenuGroup.FloorPlanId;
      this.Name = optMenuGroup.Name;

      if (allAsets?.length) {
        this.Options = optMenuGroup.OptionMenuGroupToActionSet.map(x => {
          const foundAset = allAsets.find(aset => aset.ActionSetId === x.ActionSetId);
          if (foundAset) {
            const newOptVM = new OptionVM(foundAset);
            newOptVM.SortOrder = x.SortOrder;
            return newOptVM;
          }
          return null;
        })
          .filter(Boolean)
          .sort(sortBySortOrder);
      }
    }
  }
}
